import { Outlet } from 'react-router';

import { ROUTING_PATHS } from 'const';
import { BreadcrumbRouteObject } from 'types';

const { reports } = ROUTING_PATHS;
export const REPORTS_ROUTES: BreadcrumbRouteObject[] = [
  {
    path: reports.path,
    element: <Outlet />,
    children: [
      {
        path: reports.certificationsDue.path,
        breadcrumb: { text: 'Certification due', icon: 'file outline' },
        lazy: () => import('./certification-due'),
      },
      {
        path: reports.monitoringsDue.path,
        breadcrumb: { text: 'Monitoring due', icon: 'file outline' },
        lazy: () => import('./monitoring-due'),
      },
      {
        path: reports.osmWritingMonitoring.path,
        breadcrumb: { text: 'OSM Writing Monitoring', icon: 'file outline' },
        lazy: () => import('./osm-writing-monitoring'),
      },
      {
        path: reports.eorSpeakingMonitoring.path,
        breadcrumb: { text: 'EOR Speaking Monitoring', icon: 'file outline' },
        lazy: () => import('./eor-speaking-monitoring'),
      },
      {
        path: reports.examiners.path,
        breadcrumb: { text: 'Examiners', icon: 'file outline' },
        lazy: () => import('./examiners'),
      },
      {
        path: reports.trainingAndStandardisation.path,
        breadcrumb: { text: 'Training & Standardisation', icon: 'file outline' },
        lazy: () => import('./training-and-standardisation'),
      },
      {
        path: reports.disciplinaryActionDue.path,
        breadcrumb: { text: 'Disciplinary Action Due', icon: 'file outline' },
        lazy: () => import('./disciplinary-action-due'),
      },
      {
        path: reports.odpAssessment.path,
        breadcrumb: { text: 'ODP Assessment', icon: 'file outline' },
        lazy: () => import('./odp-assessment'),
      },
      {
        path: reports.odpMonitoring.path,
        breadcrumb: { text: 'ODP Monitoring', icon: 'file outline' },
        lazy: () => import('./odp-monitoring'),
      },
    ],
  },
];
